import { takeEvery } from "redux-saga/effects";

import * as actionTypes from "../actions/actionTypes";

import { getPlaseSaga, getAlleBlokkeSaga, getBlokkeSaga, getPlaasSaga, getBlokSaga, getEenheidVerhSaga, plaasCenter } from "./plase-blokke";
import { setCurrentLocationSaga } from "./map";
import { getLayerslysSaga, kiesLayerSaga, veranderLayerFilterSaga } from './layers';
import { getLayerslysSaga_verkenning, kiesLayerSaga_verkenning, veranderLayerFilterSaga_verkenning } from './layers_verkenning';
import { getLayerslysSaga_legacy, kiesLayerSaga_legacy, veranderLayerFilterSaga_legacy } from './layers_legacy';
import { getTakeCardsSaga, getTakeCardsPerLaneSaga, stelTaakIndexSaga } from "./take";
import { getInstruksiesCardsSaga, instrInvulGetInstruksieSaga, instrInvulGetInstruksieIngevulSaga } from "./instruksies";
import { getNotificationsSaga, setNotificationGeleesSaga } from "./notifications";
import { listenToFeatureClick, stoorLayer, validateLayer, getLayerslysSaga_custom, kiesLayerSaga_custom, kiesLayerVersionSaga_custom, skepTempDrawLayer, stoorLayerVersionSaga_custom, kanselleerLayerVersionSaga_custom, maakEditableLayerVersionSaga_custom, deleteLayerVersionSaga_custom, stoorLayerNaamSaga_custom, resubscribeLayerVersionSaga_custom, kryIconsCustomLayersSaga_custom } from "./layers_custom";
import { getKultivarsSaga_Plukbepl, getWeekSaga_Plukbepl, getWeekDaeSaga_Plukbepl, getOpstellingsSaga_Plukbepl, setWeekBeginPlukbeplanSaga, setViewEenheidPlukbeplanSaga, getWeekTeikenSaga_Plukbepl, getDagTeikenSaga_Plukbepl, getDagItemSaga_Plukbepl } from "./plukbeplanner";

export function* watchKryPlase() {
    yield takeEvery(actionTypes.INIT_PLASE, getPlaseSaga);
}

export function* watchKryAlleBlokke() {
    yield takeEvery(actionTypes.INIT_ALLE_BLOKKE, getAlleBlokkeSaga);
}

export function* watchKryBlokke() {
    yield takeEvery(actionTypes.INIT_BLOKKE, getBlokkeSaga);
}

export function* watchKryPlaas() {
    yield takeEvery(actionTypes.INIT_PLAAS, getPlaasSaga);
}

export function* watchKryBlok() {
    yield takeEvery(actionTypes.INIT_BLOK, getBlokSaga);
}

export function* watchKryEenheidVerh() {
    yield takeEvery(actionTypes.GET_EENHEIDVERH, getEenheidVerhSaga);
}

export function* watchKiesPlaas() {
    yield takeEvery(actionTypes.CENTER_PLAAS, plaasCenter);
}

export function* watchKryCurrentLocation() {
    yield takeEvery(actionTypes.INIT_SET_CENTER, setCurrentLocationSaga);
}

// Layers
export function* watchKryLayerslys() {
    yield takeEvery(actionTypes.INIT_LAYERSLYS, getLayerslysSaga);
}

export function* watchKiesLayer() {
    yield takeEvery(actionTypes.KIES_LAYER, kiesLayerSaga);
}

export function* watchVeranderLayerFilter() {
    yield takeEvery(actionTypes.CHANGE_LAYERFILTER, veranderLayerFilterSaga);
}

export function* watchKryTakeCards() {
    yield takeEvery(actionTypes.INIT_TAKE_CARDS, getTakeCardsSaga);
}

export function* watchKryTakeCardsPerLane() {
    yield takeEvery(actionTypes.INIT_TAKE_CARDS_PER_LANE, getTakeCardsPerLaneSaga);
}

export function* watchSetTaakIndex() {
    yield takeEvery(actionTypes.SET_TAAK_INDEX, stelTaakIndexSaga);
}

export function* watchKryInstruksiesCards() {
    yield takeEvery(actionTypes.INIT_INSTRUKSIES_CARDS, getInstruksiesCardsSaga);
}

export function* watchInstrInvulKryInstruksie() {
    yield takeEvery(actionTypes.INSTR_INVUL_INIT_INSTRUKSIE, instrInvulGetInstruksieSaga);
}

export function* watchInstrInvulKryInstruksieIngevul() {
    yield takeEvery(actionTypes.INSTR_INVUL_INIT_INSTRUKSIE_INGEVUL, instrInvulGetInstruksieIngevulSaga);
}

export function* watchKryLayerslys_verkenning() {
    yield takeEvery(actionTypes.INIT_LAYERSLYS_VERKENNING, getLayerslysSaga_verkenning);
}

export function* watchKiesLayer_verkenning() {
    yield takeEvery(actionTypes.KIES_LAYER_VERKENNING, kiesLayerSaga_verkenning);
}

export function* watchVeranderLayerFilter_verkenning() {
    yield takeEvery(actionTypes.CHANGE_LAYERFILTER_VERKENNING, veranderLayerFilterSaga_verkenning);
}

export function* watchKryLayerslys_legacy() {
    yield takeEvery(actionTypes.INIT_LAYERSLYS_LEGACY, getLayerslysSaga_legacy);
}

export function* watchKiesLayer_legacy() {
    yield takeEvery(actionTypes.KIES_LAYER_LEGACY, kiesLayerSaga_legacy);
}

export function* watchVeranderLayerFilter_legacy() {
    yield takeEvery(actionTypes.CHANGE_LAYERFILTER_LEGACY, veranderLayerFilterSaga_legacy);
}

export function* watchKryNotifications() {
    yield takeEvery(actionTypes.GET_NOTIFICATIONS, getNotificationsSaga);
}

export function* watchMerkNotificationGelees() {
    yield takeEvery(actionTypes.REMOVE_NOTIFICATION, setNotificationGeleesSaga);
}

export function* watchListenToFeatureClick() {
    yield takeEvery(actionTypes.EDIT_TEMP_CUSTOM_LAYER, listenToFeatureClick);
    yield takeEvery(actionTypes.MAKE_LAYER_EDITABLE_CUSTOM, listenToFeatureClick);
    yield takeEvery(actionTypes.SET_LAYERSAKTIEF_VERSION_CUSTOM, listenToFeatureClick);
    yield takeEvery(actionTypes.ADD_FEATURES_PROGR_CUSTOM_LAYER, listenToFeatureClick);
}

export function* watchStoorCustomLayer() {
    yield takeEvery(actionTypes.SKEP_CUSTOM_LAYER, stoorLayer);
}

export function* watchEditCustomLayer() {
    yield takeEvery(actionTypes.EDIT_TEMP_CUSTOM_LAYER_VALIDATE, validateLayer);
}

export function* watchLayersLysCustom() {
    yield takeEvery(actionTypes.INIT_LAYERSLYS_CUSTOM, getLayerslysSaga_custom);
}

export function* watchKiesLayer_custom() {
    yield takeEvery(actionTypes.KIES_LAYER_CUSTOM, kiesLayerSaga_custom);
}

export function* watchKiesLayerVersion_custom() {
    yield takeEvery(actionTypes.KIES_LAYER_VERSION_CUSTOM, kiesLayerVersionSaga_custom);
}

export function* watchSkepTempDrawLayer() {
    yield takeEvery(actionTypes.SKEP_TEMP_CUSTOM_LAYER_INIT, skepTempDrawLayer);
}

export function* watchStoorLayerVersionCustom() {
    yield takeEvery(actionTypes.STOOR_CUSTOM_LAYER, stoorLayerVersionSaga_custom);
}

export function* watchReloadCustomLayersLys() {
    yield takeEvery(actionTypes.STOOR_NUWE_CUSTOM_LAYER_SUCCESS, getLayerslysSaga_custom);
}

export function* watchKanselleerCustomLayerVersionSaga() {
    yield takeEvery(actionTypes.SKEP_CUSTOM_LAYER_CLOSE, kanselleerLayerVersionSaga_custom);
    yield takeEvery(actionTypes.REMOVE_LAYER_VERSOIN_CUSTOM, kanselleerLayerVersionSaga_custom);
}

export function* watchResubscribeSaga() {
    yield takeEvery(actionTypes.EDIT_TEMP_CUSTOM_LAYER_KANSELLEER, resubscribeLayerVersionSaga_custom);
}


export function* watchSetLayerEditableSaga() {
    yield takeEvery(actionTypes.MAKE_LAYER_EDITABLE_CUSTOM, maakEditableLayerVersionSaga_custom);
}

export function* watchDeleteCustomLayerVersion() {
    yield takeEvery(actionTypes.DELETE_CUSTOM_LAYER_VERSION, deleteLayerVersionSaga_custom);
}

export function* watchStoorLayerNaamSage() {
    yield takeEvery(actionTypes.CHANGE_LAYER_NAME, stoorLayerNaamSaga_custom);
}

export function* watchGetIcons_CustomLayers() {
    yield takeEvery(actionTypes.GET_ICONS_CL, kryIconsCustomLayersSaga_custom);
}

export function* watchGetKultivarsSaga_Plukbepl() {
    yield takeEvery(actionTypes.GET_PLUKBEPL_KULTIVARS, getKultivarsSaga_Plukbepl);
}

export function* watchGetWeekSaga_Plukbepl() {
    yield takeEvery(actionTypes.GET_PLUKBEPL_WEEK, getWeekSaga_Plukbepl);
}

export function* watchGetWeekDaeSaga_Plukbepl() {
    yield takeEvery(actionTypes.GET_PLUKBEPL_WEEKDAE, getWeekDaeSaga_Plukbepl);
}

export function* watchGetOpstellingsSaga_Plukbepl() {
    yield takeEvery(actionTypes.GET_PLUKBEPL_OPSTELLINGS, getOpstellingsSaga_Plukbepl);
}

export function* watchSetOpstellings_WeekBegin_Saga_Plukbepl() {
    yield takeEvery(actionTypes.PLUKBEPL_SET_WEEK_BEGIN, setWeekBeginPlukbeplanSaga);
}

export function* watchSetOpstellings_ViewEenheid_Saga_Plukbepl() {
    yield takeEvery(actionTypes.PLUKBEPL_SET_VIEWEENHEID, setViewEenheidPlukbeplanSaga);
}

export function* watchSetWeekTeikenSaga_Plukbepl() {
    yield takeEvery(actionTypes.PLUKBEPL_GET_WEEKTEIKEN, getWeekTeikenSaga_Plukbepl);
}

export function* watchSetDagTeikenSaga_Plukbepl() {
    yield takeEvery(actionTypes.PLUKBEPL_GET_DAGTEIKEN, getDagTeikenSaga_Plukbepl);
}

export function* watchSetDagItemSaga_Plukbepl() {
    yield takeEvery(actionTypes.PLUKBEPL_GET_DAGITEM, getDagItemSaga_Plukbepl);
}